import { ChangeDetectionStrategy, Component, OnInit, input } from '@angular/core';
import { IonicModule, NavController, Platform } from '@ionic/angular';
import { JoyrideService } from 'ngx-joyride';

@Component({
    selector: 'app-no-selection',
    templateUrl: './no-selection.component.html',
    styleUrls: ['./no-selection.component.scss'],
    imports: [IonicModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NoSelectionComponent implements OnInit {
  readonly label = input<string>(undefined);
  readonly icon = input<string>(undefined);
  readonly color = input<string>(undefined);
  readonly lessonsTutorial = input<boolean>(false);
  readonly studentsTutorial = input<boolean>(false);
  readonly officeTutorial = input<boolean>(false);

  backButtonListener = null;

  constructor(private joyrideService: JoyrideService, private platform: Platform) {
   }

  ngOnInit() {
    this.backButtonListener = this.platform.backButton.subscribeWithPriority(
      0,
      async (processNextHandler) => {
        if (this.joyrideService.isTourInProgress) {
          this.joyrideService.closeTour();
        }
        processNextHandler();
      }
    );
  }

  ngOnDestroy() {
    this.backButtonListener.complete();
  }

  ionViewDidLeave() {
    this.backButtonListener.complete();
  }

  async startTour() {

    if (this.lessonsTutorial()) {
    this.joyrideService.startTour(
      { steps: ['overview@home/tab0', 'print-lessons-report@home/tab0', 'add-lesson@home/tab0', 'lessons-settings@home/tab4', 'dummy'], customTexts: {
        next: 'Weiter',
        prev: 'Zurück',
        done: 'Fertig'
      } }
      );
    } else if (this.studentsTutorial()) {
      this.joyrideService.startTour(
        { steps: ['student-overview@home/tab1', 'archived-students@home/tab1', 'print-student-report@home/tab1', 'add-student@home/tab1'], customTexts: {
          next: 'Weiter',
          prev: 'Zurück',
          done: 'Los gehts'
        } }
      );
    } else if (this.officeTutorial()) {
      this.joyrideService.startTour(
        { steps: ['invoice-overview@home/tab3', 'print-office-report@home/tab3', 'filter-invoices@home/tab3', 'uncharged-items@home/tab3', 'add-invoice@home/tab3', 'company-settings@home/tab4'], customTexts: {
          next: 'Weiter',
          prev: 'Zurück',
          done: 'Konto konfigurieren'
        } }
      );
    }
  }

}
